import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e670cd1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "catalog-cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogCardPreloaderComponent = _resolveComponent("CatalogCardPreloaderComponent")!
  const _component_CatalogCardComponent = _resolveComponent("CatalogCardComponent")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (row) => {
      return _withDirectives(_createVNode(_component_CatalogCardPreloaderComponent, null, null, 512), [
        [_vShow, _ctx.getCardsPreloaders.catalog]
      ])
    }), 64)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCatalogMods, (row) => {
      return _withDirectives((_openBlock(), _createBlock(_component_CatalogCardComponent, { data: row }, null, 8, ["data"])), [
        [_vShow, !_ctx.getCardsPreloaders.catalog]
      ])
    }), 256)),
    (_ctx.getPaginationData)
      ? (_openBlock(), _createBlock(_component_PaginationComponent, {
          key: 0,
          data: _ctx.getPaginationData
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}